import { CanonicalBusinessEvent } from "../types/cbes";
import { DigitalBusinessDocument } from "../types/documents";

export const extractProductIdFromCbe = (
  cbe: CanonicalBusinessEvent,
  document?: DigitalBusinessDocument
): string | null => {
  if (!document?.body?.body?.products) {
    return null;
  }
  const productIds = Object.keys(document.body.body.products);

  const matchedProduct = productIds.find((productId) =>
    cbe.idempotenceId.includes(productId)
  );
  return matchedProduct || null;
};

export const isBundleTransaction = (
  document?: DigitalBusinessDocument
): boolean => {
  return document?.body?.metadata?.internalAttributes?.IS_BUNDLE === "true";
};

export const isBundleNonSplitTransaction = (
  document?: DigitalBusinessDocument
): boolean => {
  return (
    document?.body?.metadata?.internalAttributes?.IS_BUNDLE === "true" &&
    document?.body?.body?.products !== undefined &&
    Object.keys(document.body.body.products).length === 1
  );
};

export const groupCbesByProduct = (
  cbes: CanonicalBusinessEvent[],
  document?: DigitalBusinessDocument
): Map<string, CanonicalBusinessEvent[]> => {
  const groups = new Map<string, CanonicalBusinessEvent[]>();

  cbes.forEach((cbe) => {
    const productId = extractProductIdFromCbe(cbe, document);
    if (productId === null) {
      return;
    }

    if (!groups.has(productId)) {
      groups.set(productId, []);
    }
    groups.get(productId)?.push(cbe);
  });

  groups.forEach((cbeList) => {
    cbeList.sort((a, b) => a.lockVersion - b.lockVersion);
  });

  return groups;
};
